<template>
  <div class="categorise-select-content animate__slideInUp animate__animated animate__faster">
    <div class="scroll">
      <div class="text-right close-icon" @click="closePopup()">
        <i class="fas fa-times" />
      </div>
      <div class="index" :style="{'background-color': selectedOption.color}">
        {{ selectedOption.index }}
      </div>
      <h3 class="selected-option-title">
        {{ selectedOption.value }}
      </h3>
      <p>Match with:</p>
      <div class="categorise-select-title">
        <div
          v-for="(category, index) in categories"
          class="pair-title-item horizontal layout center"
          :key="index"
          @click="selectPair(category, index)"
          :class="{
            'disabled': slide.quizStatus == QuizStatuses.RESULT_SCREEN || isFormSubmitted,
            'correct': slide.quizStatus == QuizStatuses.RESULT_SCREEN && category.options.includes(selectedOption.value),
            'incorrect': slide.quizStatus == 5 && !category.options.includes(selectedOption.value),
            'selected': (selectedOption.answer === category.value),
          }"
        >
          <AhaRadio
            v-if="slide.quizStatus != QuizStatuses.RESULT_SCREEN"
            size="lg"
            class="mr-2"
            :checked="selectedOption.answer == category.value"
          />

          <span v-if="slide.quizStatus != QuizStatuses.RESULT_SCREEN">
            <AhaKeyV2
              class="bold"
              :index="index"
              :backgroundColorMap="CATEGORY_COLOR_MAP"
            />
          </span>

          <AhaSvg
            v-if="slide.quizStatus == QuizStatuses.RESULT_SCREEN && category.options.includes(selectedOption.value)"
            name="correct"
            view-box="0 0 18 18"
            maintain-color
            class="aha-option__icon icon-correct"
          />
          <AhaSvg
            v-if="slide.quizStatus == QuizStatuses.RESULT_SCREEN && !category.options.includes(selectedOption.value)"
            name="incorrect"
            view-box="0 0 18 18"
            maintain-color
            class="aha-option__icon icon-incorrect"
          />
          <div class="flex pair-title-text">
            {{ category.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import QuizStatuses from '@/constants/QuizStatuses'
import { CATEGORY_COLOR_MAP } from '@/constants/categorise.constants'
import AhaRadio from '../common/Radio.vue'
import AhaKeyV2 from '../common/KeyV2.vue'

export default {
  components: {
    AhaRadio,
    AhaKeyV2,
  },
  props: {
    selectedOption: {
      type: Object,
      default: () => {},
    },
    categories: {
      type: Array,
      default: () => [],
    },
    isFormSubmitted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectPairItem: null,
      QuizStatuses,
      CATEGORY_COLOR_MAP,
    }
  },
  computed: {
    ...mapGetters({ slide: 'activeActivity' }),
  },
  methods: {
    selectPair(category, index) {
      if (this.slide.quizStatus == QuizStatuses.RESULT_SCREEN || this.isFormSubmitted) return
      this.$emit('selectOption', category, index)
      this.closePopup()
      this.$store.dispatch('updateSlide', this.slide)
    },
    closePopup() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.close-icon {
  position: absolute;
  top: -28px;
  right: 0px;
  cursor: pointer;
  padding: 6px 10px 5px;
  z-index: 100;
  color: #fff;
  background-color: #000;
  border-radius: 25px;
  font-size: 10px;
  text-transform: uppercase;
}
.categorise-select-content {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  max-width: 600px;
  margin: 0 auto;
  z-index: 2;
  position: relative;
  padding-bottom: 0;
  line-height: 1.4;
  color: #333333;
  text-align: left;

  .scroll {
    height: 100%;
    width: 100%;
    overflow-y: auto;
  }
}

.index {
  width: 28px;
  height: 28px;
  border-radius: 28px;
  text-align: center;
  line-height: 28px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  margin-right: 16px;
}
.title {
  font-size: 14px;
  font-weight: bold;
}
.selected-option-title {
  padding: 14px;
  background: rgba(240, 244, 250, 1);
  border-radius: 4px;
  border: 1px solid rgba(211, 215, 225, 1);
  margin: 0;
}
.pair-title-item {
  border: 1px solid #D3D7E1;
  border-radius: 4px;
  margin: 8px 0;
  padding: 10px;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
  &.incorrect.selected {
    border: 2px solid #FF4954;
    background-color: rgba(255, 73, 84, 0.5);
  }
  &.correct.selected {
    border: 2px solid #33C173;
    background-color: rgba(51, 193, 115, 0.4);
  }
  &.disabled {
    cursor: not-allowed;
  }

  &.has-img {
    display: block;
    position: relative;

    & .aha-radio {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

  }
}

.pair-img {
  width: 50%;
  height: auto;
  border-radius: 4px;
  margin-bottom: 4px;
}
.pair-title-text {
  padding-left: 10px;
}
.option-title {
  margin-top: 8px;
  margin-bottom: 16px;
  align-items: center;
}
.categorise-selected {
  width: 24px;
  height: 24px;
  text-align: center;
  border-radius: 18px;
  background-color: #EFF1F7;
  font-size: 14px;
  line-height: 24px;
}
</style>
